module.exports = __webpack_public_path__ + "img/industry_background.9dab8266.png";